import { render, staticRenderFns } from "./meterInfo.vue?vue&type=template&id=38d9cb38&scoped=true&"
import script from "./meterInfo.vue?vue&type=script&lang=js&"
export * from "./meterInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d9cb38",
  null
  
)

export default component.exports